module.exports = __webpack_public_path__ + "img/9791187777465.215c0246.jpg";